import { Controller } from '@hotwired/stimulus';

// Connects to data-controller="dropdown"
// Used in: navbar search
// Purpose: handle scroll and enter key events on search results dropdown
// Explanation: works together with search and highlight controller.
export default class extends Controller {
  static targets = ['select', 'dropdown'];
  static values = {
    index: Number, // used for showing slides
  };

  connect() {
    console.log('dropdown controller connectedd');
    // set index value and add up, down and enter key events
    this.indexValue = 0;
    let context = this;
    const listener = (e) => {
      // On arrow up/down, change index value
      if (this.selectTargets.length > 0) {
        let selected = document.querySelector('.selected-search-result');
        let dropdown = context.dropdownTarget;
        if (e.which === 38) {
          console.log('up');
          this.indexValue--;
          dropdown.scrollTop = selected.offsetTop - 100;
        } else if (e.which === 40) {
          console.log('down');
          this.indexValue++;
          dropdown.scrollTop = selected.offsetTop;
        } else if (e.which === 13) {
          console.log('enter');
          document.querySelector('.selected-search-result').click();
        }

        // If index value is out of bounds, reset it
        if (this.indexValue < 0) {
          this.indexValue = 0;
        } else if (this.indexValue > this.selectTargets.length - 1) {
          this.indexValue = this.selectTargets.length - 1;
        }
      }
    };
    window.addEventListener('keydown', listener);
  }
  indexValueChanged() {
    // When index value has changed, show current selected result and hide the others
    if (this.selectTargets.length > 0) {
      this.highlightSelection();
    }
  }

  highlightSelection() {
    // highlight the current selection
    let context = this;
    this.selectTargets.forEach((element, index) => {
      if (index === context.indexValue) {
        element.classList.add('selected-search-result');
      } else {
        element.classList.remove('selected-search-result');
      }
    });
  }
}
